<object>
  <embed [src]="safeUrl" #rptView class="loadingApex" width="100%" height="800">
</object>